import { ColorPicker } from './../../../Core/GeneralProperties/Managers/ColorPicker/ColorPicker';
import * as $ from 'jquery';
import { messages, Notifier } from './../../../Core/Common/Notifier';
import { BlockUI } from '../../../Core/Common/BlockUi';
import { Modal } from '../../../Core/Common/Modal';
import { AssistantApi } from './AssistantApi';
import { Guid } from 'Core/Common/Guid';

import AssistantTemplate from 'DatabaseDesigner/Components/Assistant/Templates/AssistantTemplate.html';
import ChatkitTemplate from 'DatabaseDesigner/Components/Assistant/Templates/ChatKit.html';

import { MessageDto } from './Models/MessageDto';
import { DatabaseModel } from '../../Models/DatabaseDesignerModel';
import { GeneratedTables } from './GeneratedTables';
import { Event } from 'Core/Common/Event';
import { AIDBStructure } from './Models/AIDBStructure';
import { AITableDefinition } from './Models/AITableDefinition';
import { AIFieldDefinition } from './Models/AIFieldDefinition';
import { SortGroups, TABLE_TYPES } from 'Core/Constant';
import { CONFIRMATIONS, LABELS, NOTIFICATIONS } from 'Core/Components/Translation/Locales';
import { RecordStore } from 'Core/Common/Stores/RecordStore';
import { UserManager } from 'User/UserManager';
import { Table } from 'Core/Components/BackLinking/Popup/MakeBackLink/Models/View/Table';
import { TableStore } from 'Core/Common/Stores/TableStore';
import moment from 'moment';
import { is, resolve } from 'cypress/types/bluebird';
import {
    ConfirmationDialog,
    EVENTS,
    Types,
} from 'Core/Components/Dialogs/ConfirmationDialog/ConfirmationDialog';
import { PromptDto } from 'DatabaseDesigner/Components/Assistant/Models/PromptDto';
import { OpenAIChatKit } from '@openai/chatkit';
import { reject } from 'underscore';

ko.templates['DatabaseDesigner/Components/Assistant/Templates/AssistantTemplate'] =
    AssistantTemplate;
ko.templates['DatabaseDesigner/Components/Assistant/Templates/ChatKit'] = ChatkitTemplate;

export enum AssistantModes {
    Database,
    Help,
    Planning,
    GuesPlanning,
    Workflow,
    SQL,
    CSharp
}

type AppointmentOption = {
    startTime: string;
    address?: string;
    name?: string;
    endTime: string;
    isSelected?: KnockoutObservable<boolean>;
    isDisabled?: KnockoutObservable<boolean>;
    user_id?: number[];
    users?: number[];
};

export class Assistant extends Event {
    private _modal: Modal;
    private _messages: KnockoutObservableArray<MessageDto>;
    private _userInput: KnockoutObservable<string>;
    private _chatHistory: KnockoutComputed<Array<MessageDto>>;
    private _database: any;

    private _labels = LABELS;
    private _mode: AssistantModes;
    private _responseId: string;
    private _isDatabaseAssistant: boolean;
    private _isSQLAssistant: boolean;
    private _isFunctionAssistant: boolean;
    private _entityId: number;
    private _recordId: number;
    private _controlId: number;
    private _commandId: number;
    private _commandToken: string;
    private _isShiftEnterActive: KnockoutObservable<boolean>;
    private _isEnterActive: KnockoutObservable<boolean>;
    private _textareaRows: KnockoutObservable<number>;
    private _isPending: KnockoutObservable<boolean>;
    private _typingContent: KnockoutObservable<string> = ko.observable('');
    private _typingInterval?: number;
    private _typingMessage = ko.observable<MessageDto | null>(null);
    private _placeholder: KnockoutObservable<string>;
    private _scrollHandler?: () => void;
    private _scrollButton: KnockoutObservable<boolean>;

    public inputClasses: KnockoutComputed<string>;
    Appointments: KnockoutObservableArray<AppointmentOption> = ko.observableArray([]);
    IsEnablePlanning: KnockoutComputed<boolean>;
    private _dbName: string;
    private _sqlText: string;
    private _sqlError: string;

    private _functionText: string;
    private _functionError: string;

    GetTemplateName: KnockoutComputed<string>;

    constructor({
        database,
        mode,
        entityId,
        recordId,
        controlId,
        commandId,
        commandToken,
        dbName,
        sqlText,
        sqlError,
        functionText,
        functionError  
    }: {
        database?: any;
        mode: AssistantModes;
        entityId?: number;
        recordId?: number;
        controlId?: number;
        commandId?: number;
        commandToken?: string;
        dbName?: string;
        sqlText?: string;
        sqlError?: string; 
        functionText?: string;
        functionError?: string; 
    }) {
        super();
        this._mode = mode;
        this._entityId = entityId;
        this._recordId = recordId;
        this._controlId = controlId;
        this._database = database;
        this._commandId = commandId;
        this._commandToken = commandToken;
        this._dbName = dbName;
        this._sqlText = sqlText;
        this._sqlError = sqlError;
        this._functionText = functionText;
        this._functionError = functionError;

        this._isPending = ko.observable(false);
        this._placeholder = ko.observable('');
        this._scrollButton = ko.observable(false);

        this._isDatabaseAssistant = this._mode === AssistantModes.Database;
        this._isSQLAssistant = this._mode === AssistantModes.SQL;
        this._isFunctionAssistant = this._mode === AssistantModes.CSharp;

        this._userInput = ko.observable('');
        this._messages = ko.observableArray([]);

        this.IsEnablePlanning = ko.computed(() => {
            return (
                this.Appointments().filter((appointment) => appointment.isSelected()).length == 0
            );
        });

        this._chatHistory = ko.computed(() => {
            let result = [];

            if (this._messages().length > 0) {
                let lastElelement = this._messages()[this._messages().length - 1];

                if (this.IsAppointmentJson(lastElelement.Content)) {
                    this.CreateChatAppointment(lastElelement.Content);
                }
            }

            this._messages().forEach((message) => {
                if (this.IsJson(message.Content)) {
                    return;
                }
                message.Content = message.Content.replace(/\n/g, '<br>');
                result.push(message);
            });

            this.ScrollModalToBottom();

            return result;
        });

        this.ApplyText();

        this._isShiftEnterActive = ko.observable(false);
        this._isEnterActive = ko.observable(false);
        this._textareaRows = ko.observable(1);
        this.inputClasses = ko.computed(() => {
            const classes = [
                'rounded-[30px]',
                'border-1',
                'border-border',
                'bg-muted',
                'relative',
                'flex',
                'w-full',
                'cursor-text',
                'flex-col',
                'overflow-hidden',
                'ps-4',
            ];

            if (this._isShiftEnterActive()) {
                classes.push('pt-2');
                classes.push('pb-11');
            } else {
                classes.push('pt-4');
                classes.push('pb-4');
            }

            if (!this._isShiftEnterActive() && (this._isDatabaseAssistant || this._isSQLAssistant)) {
                classes.push('pe-[96px]');
            } else if (!this._isShiftEnterActive() && !this._isDatabaseAssistant && !this._isSQLAssistant) {
                classes.push('pe-[52px]');
            } else if (this._isShiftEnterActive()) {
                classes.push('pe-4');
            }

            if (this._isShiftEnterActive()) {
                classes.push('shift-enter-active');
            } else {
                classes.push('shift-enter-not-active');
            }

            if (this._isEnterActive()) {
                classes.push('enter-active');
            }

            return classes.join(' ');
        });

        this.GetTemplateName = ko.computed(() => {
            if (this._mode === AssistantModes.Workflow) {
                return 'DatabaseDesigner/Components/Assistant/Templates/ChatKit';
            }

            return 'DatabaseDesigner/Components/Assistant/Templates/AssistantTemplate';
        });
    }

    TypeMessage(content: string, speed: number = 10) {

        /*if (this._typingInterval) {
            clearInterval(this._typingInterval);
        }

        this._typingContent('');
        let index = 0;

        this._typingInterval = window.setInterval(() => {
            if (index < content.length) {
                const char = content[index];
                this._typingContent(this._typingContent() + (char === '\n' ? '<br>' : char));
                index++;
            } else {
                clearInterval(this._typingInterval);
                this._typingInterval = undefined;
                this._typingMessage(null);
            }
        }, speed);*/

        this._typingContent(content);
    }

    private AddAssistantMessage(raw: any, speed?: number) {
        if (!raw) {
            return;
        }

        const message = new MessageDto();
        message.Id = raw.Id ?? Guid.NewGuid();
        message.Role = raw.Role;
        message.Content = raw.Content;

        this._messages.push(message);

        if (message.Role?.toLowerCase() === 'assistant') {
            this._typingMessage(message);
            this._typingContent('');
            setTimeout(() => this.TypeMessage(message.Content), 50);
        }
    }

    FormatTime(startTime: string) {
        return moment(startTime).format('HH:mm, D [of] MMMM YYYY');
    }

    ApplyText() {
        switch (this._mode) {
            case AssistantModes.Help:
                this._placeholder(this._labels.WRITE_QUESTION);
                break;
            case AssistantModes.SQL:
                this._placeholder(this._labels.WRITE_QUESTION);
                break;
            case AssistantModes.Planning:
                this._placeholder(this._labels.ENTER_PLANNING_DETAILS);
                break;
            case AssistantModes.GuesPlanning:
                this._placeholder(this._labels.ENTER_PLANNING_DETAILS);
                break;
            default:
                this._placeholder(this._labels.ENTER_YOUR_MESSAGE);
                break;
        }
    }

    async CreateChatAppointment(appoinmentJson: string) {
        let appoinmentJSON = JSON.parse(appoinmentJson);
        await this.CreateAppointment({
            startTime: appoinmentJSON.starttime,
            endTime: appoinmentJSON.endtime,
            users: appoinmentJSON.users,
            name: appoinmentJSON.name,
        });

        this.Appointments([
            {
                startTime: appoinmentJSON.starttime,
                endTime: appoinmentJSON.endtime,
                isSelected: ko.observable(true),
                users: appoinmentJSON.users,
            },
        ]);
    }

    async LoadData(refreshMetadata: boolean = false) {
        BlockUI.Block({ Target: this.Container });

        this.ApplyText();

        if (this._mode === AssistantModes.Database) {
            let prompt = await AssistantApi.AssistantMessage({
                ChatHistory: [],
                Database: this.SerializeDbStructure(),
            })
                .fail(() => {})
                .fail((err) => {
                    BlockUI.Unblock(this.Container);
                    Notifier.Failed(err.message);
                });

            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
        }

        if (
            this._mode === AssistantModes.Help ||
            this._mode === AssistantModes.Planning ||
            this._mode === AssistantModes.Workflow ||
            this._mode === AssistantModes.GuesPlanning ||
            this._mode === AssistantModes.SQL ||
            this._mode === AssistantModes.CSharp
        ) {
            if (this._mode === AssistantModes.Help) {
                let welcomeMessage = new MessageDto();
                welcomeMessage.Content = this.GetWelcomeMessage();
                welcomeMessage.Role = 'assistant';
                this.AddAssistantMessage(welcomeMessage, 10);
            }

            this._responseId = '';

            if (this._mode === AssistantModes.SQL) {
                await AssistantApi.CreateSQLThread(refreshMetadata, JSON.stringify(this.SerializeDbStructure())).fail((err) => {
                    BlockUI.Unblock(this.Container);
                    Notifier.Failed(err.message);
                });
            } else if (this._mode === AssistantModes.Workflow) {
                this._responseId = await AssistantApi.CreateWorkflowThread(this._controlId).fail((err) => {
                    BlockUI.Unblock(this.Container);
                    Notifier.Failed(err.message);
                });
            }
        }

        if (this._mode === AssistantModes.CSharp) {
            let prompt = await AssistantApi.StartFunctionChat({
                ResponseId: this._responseId,
                Function: this._functionText,
                Error: this._functionError
            }).fail((err) => {
                Notifier.Failed(err.message);
                BlockUI.Unblock(this.Container);
            });

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
        }

        if (this._mode === AssistantModes.SQL) {
            let prompt = await AssistantApi.StartSQLChat({
                ResponseId: this._responseId,
                SQL: this._sqlText,
                Error: this._sqlError
            }).fail((err) => {
                Notifier.Failed(err.message);
                BlockUI.Unblock(this.Container);
            });

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
        }

        if (this._mode === AssistantModes.Planning) {
            let prompt = await AssistantApi.StartPlanningChat({
                EntityId: this._entityId,
                RecordId: this._recordId,
                ControlId: this._controlId,
                ResponseId: this._responseId,
            }).fail((err) => {
                Notifier.Failed(err.message);
                BlockUI.Unblock(this.Container);
            });

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
        }

        if (this._mode === AssistantModes.GuesPlanning) {
            let appoinments = await AssistantApi.StartGuestPlanningChat({
                EntityId: this._entityId,
                RecordId: this._recordId,
                ResponseId: this._responseId,
                CommandId: this._commandId,
                CommandToken: this._commandToken,
                IsChatSession: false,
            }).fail((err) => {
                Notifier.Failed(err.message);
                BlockUI.Unblock(this.Container);
            });

            this.CaptureResponseId(appoinments);

            if (appoinments.Messages.length > 0) {
                this.SetAppointments(appoinments.Messages[appoinments.Messages.length - 1].Content);
            }
            this.AddAssistantMessage(this.GetAssistantMessage(appoinments));
        }

        BlockUI.Unblock(this.Container);
    }

    SetAppointments(appoinments: string) {
        if (this.IsAppointmentsJson(appoinments)) {
            let appointmnets: Array<AppointmentOption> = [];

            _.each(JSON.parse(appoinments), (appointmnet: any) => {
                appointmnets.push({
                    startTime: appointmnet.starttime,
                    endTime: appointmnet.endtime,
                    name: appointmnet.name,
                    address: appointmnet.address,
                    isSelected: ko.observable(false),
                    isDisabled: ko.observable(false),
                    user_id: appointmnet.users,
                    users: appointmnet.users,
                });
            });

            this.Appointments(appointmnets);
        }
    }

    private GetWelcomeMessage() {
        if (this._mode === AssistantModes.Help) {
            return `Hello, and welcome to Spheeres Assistant – your dedicated helper for all things Spheeres! I’m here to provide quick answers, guidance, and support to help you make the most of your experience with Spheeres.
        If you have questions or need assistance, just reach out – I'm here to help!
        Let’s make Spheeres work for you!`;
        }
        return '';
    }

    SerializeDbStructure(): AIDBStructure {
        let dbStructure = new AIDBStructure();
        let tables = [...this._database.Tables, ...this._database.LinkTables];

        _.each(tables, (table: any) => {
            if (table.Name.startsWith('SYS_')) {
                return;
            }

            let aiTable = this.BuildTable(table);
            aiTable.Type =
                this._database.Tables.indexOf(table) >= 0 ? TABLE_TYPES.Entity : TABLE_TYPES.Link;

            dbStructure.Tables.push(aiTable);
        });

        return dbStructure;
    }

    BuildTable(table) {
        let aiTable = new AITableDefinition();
        aiTable.Name = table.Name;

        _.each(table.Fields, (field: any) => {
            if (!SortGroups.InCustom(field.Sort)) {
                return;
            }
            let aiField = new AIFieldDefinition();
            aiField.Name = field.Name;
            aiField.Type = field.TypeName;
            aiTable.Fields.push(aiField);
        });
        return aiTable;
    }

    async Show() {
        const self = this;

        this._modal = new Modal(
            {
                heightInPercent: '100%',
                width: '40vw',
                height: 'calc(100vh - 40px)',
                addClass: 'ai-assistant-modal right-fixed-modal',
                position: {
                    x: 'right',
                    y: 'top',
                },
                offset: { x: -20, y: 20 },
                closeOnEsc: false,
                animation: 'slide:right',
                overlay: !this._isSQLAssistant,
                onOpen: function () {
                    $(this.closeButton[0]).off('click');
                    this.closeButton[0].addEventListener('click', self.Close.bind(self));

                    // For SQL mode: convert to right-based positioning and enable resize
                    if (self._isSQLAssistant) {
                        const $container = $(this.container);
                        const $content = $container.find('.jBox-content');
                        const windowWidth = $(window).width();

                        // Switch to right-based positioning (20px from right edge)
                        $container.css({
                            'left': 'auto',
                            'right': '20px'
                        });

                        // Apply resizable with west handle
                        $container.resizable({
                            handles: 'w',
                            minWidth: 300,
                            maxWidth: windowWidth - 100,
                            resize: function (_event, ui) {
                                // Prevent jQuery UI from setting left, keep right-based positioning
                                ui.position.left = null;
                                $container.css({
                                    'left': 'auto',
                                    'right': '20px'
                                });
                                $content.css('width', '100%');
                            }
                        });
                    }
                },
            },
            false
        );

        ko.cleanNode(this._modal.Wrapper);
        ko.applyBindings(this, this._modal.Wrapper);
        this._modal.Show();

        if (this._mode === AssistantModes.Workflow) {
            let threadId = null;
            let apiToken = null;
            let saveResult = false;

            const chatkit = document.createElement('openai-chatkit') as OpenAIChatKit;

            chatkit.setOptions({
                header: {
                    enabled: false
                },
                threadItemActions: {
                    feedback: false             
                },
                api: {
                    getClientSecret: async () => {
                        BlockUI.Block({ Target: this.Container });
                        apiToken = await AssistantApi.CreateWorkflowThread(this._controlId)
                        .always(() => {
                            BlockUI.Unblock(this.Container);
                        }).fail(errr=>Notifier.Failed(errr.message));
                        return apiToken;
                    },
                },
                composer: {                    
                    tools: [
                        {
                            id: 'generate-final',
                            label: 'Save',
                            icon: 'write-alt',
                            pinned: true,
                        },
                    ],
                },
            });

            chatkit.addEventListener('chatkit.log', async (event: CustomEvent) => {
                if (event.detail.data.toolId == 'generate-final') {
                    saveResult = true;
                    await chatkit.sendUserMessage({ text: 'GENERATE THE FINAL RESULT TO SAVE IT' });
                }
            });

            chatkit.addEventListener('chatkit.error', (event: CustomEvent) => {
                if(event.detail.error.message == 'No handler for client tool calls. You\'ll need to add onClientTool to your ChatKit options.'){
                    return;
                }
                Notifier.Failed(event.detail.error.message);
            });

            chatkit.addEventListener('chatkit.thread.change', (payload: CustomEvent) => {
                threadId = payload.detail.threadId;
            });

            chatkit.addEventListener('chatkit.response.end', async () => {
               if(saveResult){
                BlockUI.Block({ Target: this.Container });
                await AssistantApi.SaveWorkflowResult({
                    EntityId: this._entityId,
                    RecordId: this._recordId,
                    ThreadId: threadId,
                    ControlId: this._controlId,
                    Token: apiToken
                }).always(()=>{
                    BlockUI.Unblock(this.Container);
                });
                Notifier.Success(NOTIFICATIONS.RECORD_SAVED);
                saveResult = false;
               }
            });

            BlockUI.Block({ Target: this.Container });
            let queryData = await AssistantApi.StartWorkflowChat({
                EntityId: this._entityId,
                RecordId: this._recordId,
                ControlId: this._controlId            
            }).always(()=>{
                 BlockUI.Unblock(this.Container);
            });

            chatkit.sendUserMessage({ text: queryData });

            $(this._modal.Wrapper).find('.assistant-template').append(chatkit);
        }

        this.SetupScrollButton();
    }

    ScrollButton() {
        this.ScrollToBottom();
    }

    private ScrollToBottom() {
        const $container = $(this._modal?.Wrapper)?.closest('.jBox-content');
        if ($container?.length) {
            $container.stop().animate({ scrollTop: $container[0].scrollHeight }, 300);
        }
    }

    private SetupScrollButton() {
        if (!this._modal?.Wrapper) {
            return;
        }

        const $container = $(this._modal.Wrapper).closest('.jBox-content');
        if (!$container.length) {
            return;
        }

        this._scrollHandler = () => {
            const el = $container[0];
            if (!el) {
                return;
            }

            const scrollHeight = el.scrollHeight;
            const scrollTop = el.scrollTop;
            const containerHeight = el.clientHeight;

            const distanceToBottom = scrollHeight - (scrollTop + containerHeight);

            if (distanceToBottom > 30) {
                if (!this._scrollButton()) {
                    this._scrollButton(true);
                }
            } else {
                if (this._scrollButton()) {
                    this._scrollButton(false);
                }
            }
        };

        $container.on('scroll', this._scrollHandler);

        const originalClose = this._modal.Close.bind(this._modal);
        this._modal.Close = () => {
            if (this._scrollHandler) {
                $container.off('scroll', this._scrollHandler);
            }
            originalClose();
        };
    }

    get Container() {
        return this._modal ? $(this._modal.Wrapper).closest('.jBox-content')[0] : null;
    }

    async SendMessage() {
        if (this._isPending() || !this._userInput()) {
            return;
        }

        this._isPending(true);

        let newMessage = new MessageDto();
        newMessage.Content = this._userInput();
        newMessage.Role = 'user';

        this._messages.push(newMessage);
        this.CleanTextArea();

        let messages = [...this._messages()];

        if (this._mode === AssistantModes.Database) {
            let prompt = await AssistantApi.AssistantMessage({
                ChatHistory: messages,
                Database: this.SerializeDbStructure(),
            })
                .always(() => {
                    this.CleanTextArea();
                    this._isPending(false);
                })
                .fail((err) => Notifier.Failed(err.message));

            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
            this._userInput('');
        }

        if (this._mode === AssistantModes.Help) {
            let prompt = await AssistantApi.HelpAssistantMessage({
                Message: this._userInput(),
                responseId: this._responseId,
            })
                .always(() => {
                    this.CleanTextArea();
                    this._isPending(false);
                })
                .fail((err) => Notifier.Failed(err.message));

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
            this._userInput('');
        }

        if (this._mode === AssistantModes.Planning) {
            let prompt = await AssistantApi.PlannerMessage({
                Message: this._userInput(),
                responseId: this._responseId,
            })
                .always(() => {
                    this.CleanTextArea();
                    this._isPending(false);
                })
                .fail((err) => Notifier.Failed(err.message));

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
            this._userInput('');
        }

        if (this._mode === AssistantModes.SQL) {
            let prompt = await AssistantApi.SqlMessage({
                Message: this._userInput(),
                responseId: this._responseId,
            })
                .always(() => {
                    this.CleanTextArea();
                    this._isPending(false);
                })
                .fail((err) => Notifier.Failed(err.message));

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
            this._userInput('');
        }

        if (this._mode === AssistantModes.GuesPlanning) {
            let prompt = await AssistantApi.GuestPlannerMessage({
                Message: this._userInput(),
                responseId: this._responseId,
                CommandId: this._commandId,
                CommandToken: this._commandToken,
            })
                .always(() => {
                    this.CleanTextArea();
                    this._isPending(false);
                })
                .fail((err) => Notifier.Failed(err.message));

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
            this._userInput('');
        }

        if (this._mode === AssistantModes.CSharp) {
            let prompt = await AssistantApi.SendFunctionMessage({
                Message: this._userInput(),
                responseId: this._responseId,
            })
                .always(() => {
                    this.CleanTextArea();
                    this._isPending(false);
                })
                .fail((err) => Notifier.Failed(err.message));

            this.CaptureResponseId(prompt);
            this.AddAssistantMessage(this.GetAssistantMessage(prompt));
            this._userInput('');
        }

        this.CleanTextArea();
        this._isPending(false);
    }

    CreateTables() {
        BlockUI.Block();
        AssistantApi.GenerateStructure({
            ChatHistory: this._messages(),
            Database: this.SerializeDbStructure(),
        })
            .always(() => BlockUI.Unblock())
            .fail((err) => Notifier.Failed(err.message))
            .then((data) => {
                this.ShowTablesModal(data);
            });
    }

    ShowTablesModal(json) {
        let database = new DatabaseModel();
        database.FromJSON(json);

        let generatedTables = new GeneratedTables(database);
        generatedTables.On('SAVE', this, () => {
            this.Trigger('SAVE', database);
            this._modal.Close();
        });
        generatedTables.Show();
    }

    Close() {
        if (this._modal) {
            this._modal.Close();
            this._messages([]);
        }
    }

    FormatMessage(message: MessageDto) {
        return message.Content.replace(/\n/g, '<br>');
    }

    IsJson(jsonString: string) {
        try {
            JSON.parse(jsonString);
        } catch (error) {
            return false;
        }

        return true;
    }

    IsAppointmentsJson(jsonString) {
        const appointmentKeys = ['starttime', 'endtime', 'address'];
        let parsedObject;

        try {
            parsedObject = JSON.parse(jsonString);
            let isArray = Array.isArray(parsedObject);

            if (!isArray) {
                return false;
            }

            parsedObject = parsedObject[0];
        } catch (error) {
            return false;
        }

        if (typeof parsedObject !== 'object' || parsedObject === null) {
            return false;
        }

        for (const key of appointmentKeys) {
            if (!parsedObject.hasOwnProperty(key)) {
                return false;
            }
        }

        return true;
    }

    IsAppointmentJson(jsonString) {
        const appointmentKeys = ['starttime', 'name', 'endtime', 'users'];
        let parsedObject;

        try {
            parsedObject = JSON.parse(jsonString);
        } catch (error) {
            return false;
        }

        if (typeof parsedObject !== 'object' || parsedObject === null) {
            return false;
        }

        for (const key of appointmentKeys) {
            if (!parsedObject.hasOwnProperty(key)) {
                return false;
            }
        }

        return true;
    }

    async CreateAppointment(appointment: AppointmentOption) {
        BlockUI.Block({ Target: this.Container });

        let record = await AssistantApi.CreateAppiontment({
            StartTime: moment(appointment.startTime).utc().format(),
            EndTime: moment(appointment.endTime).utc().format(),
            Name: appointment.name,
            Users: appointment.users,
            EntityId: this._entityId,
            RecordId: this._recordId,
            CommandToken: this._commandToken,
        }).fail((err) => {
            BlockUI.Unblock(this.Container);
            Notifier.Failed(err.message);
        });

        let nameField = record.Fields.find((f) => f.FieldName === 'NAME');
        let message = '';

        if (UserManager.Instance.CurrentUser) {
            let agenda = await TableStore.Get({ TableName: 'AGENDA' });
            let url = new URL(window.location.href);
            let dbName = UserManager.Instance.CurrentUser?.DbName || this._dbName;
            let urlForCopying = `${url.origin}/view?db=${dbName}&recordId=${record.RecordId}&entityId=${agenda.Id}`;
            message = `Appointment <a href='${urlForCopying}'>${nameField.FieldValue}</a> created successfully!`;
        } else {
            message = `Appointmen ${nameField.FieldValue} created successfully!`;
        }

        Notifier.Success(message, {
            closeOnClick: false,
            duration: 15000,
        });
        this._modal?.Close();
        BlockUI.Unblock(this.Container);
        return record;
    }

    UpdateRows(textarea: HTMLTextAreaElement) {
        if (!textarea) {
            return;
        }

        const value = textarea.value;

        if (!value.trim()) {
            this._textareaRows(1);
            this._isShiftEnterActive(false);
            return;
        }

        const style = getComputedStyle(textarea);
        const lineHeight = parseInt(style.lineHeight || '20', 10);

        const rows = Math.ceil(textarea.scrollHeight / lineHeight);

        const clampedRows = Math.min(Math.max(rows, 1), 6);
        this._textareaRows(clampedRows);

        this._isShiftEnterActive(value.includes('\n') || clampedRows > 1);
    }

    OnInput = (data, event) => {
        const textarea = event.target as HTMLTextAreaElement;
        this.UpdateRows(textarea);
    };

    OnEnter(data, event) {
        const isEnter = event.key === 'Enter';
        const isShift = event.shiftKey;

        if (!isEnter) {
            return true;
        }

        const textarea = event.target as HTMLTextAreaElement;

        if (isEnter && !isShift) {
            event.preventDefault();
            this._isEnterActive(true);
            this.SendMessage().then(() => this.CleanTextArea());
            return false;
        }

        if (isEnter && isShift) {
            event.preventDefault();
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const currentValue = this._userInput();
            const newValue = currentValue.slice(0, start) + '\n' + currentValue.slice(end);
            this._userInput(newValue);

            setTimeout(() => {
                textarea.selectionStart = textarea.selectionEnd = start + 1;
                this.UpdateRows(textarea);
                const rows = this._textareaRows();
                if (rows >= 6) {
                    textarea.scrollTop = textarea.scrollHeight;
                }
            }, 0);

            return false;
        }

        return true;
    }

    OnPaste(data, event) {
        const clipboardData = event.clipboardData || window['clipboardData'];
        let pastedText = clipboardData?.getData('text') ?? '';

        if (!pastedText) {
            return true;
        }

        pastedText = pastedText.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

        const textarea = event.target as HTMLTextAreaElement;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const currentValue = this._userInput();
        const newValue = currentValue.slice(0, start) + pastedText + currentValue.slice(end);
        this._userInput(newValue);

        setTimeout(() => this.UpdateRows(textarea), 0);

        event.preventDefault();
        return false;
    }

    CleanTextArea() {
        this._isEnterActive(false);
        this._isShiftEnterActive(false);
        this._textareaRows(1);
        this.ScrollModalToBottom();
    }

    ScrollModalToBottom() {
        setTimeout(() => {
            const $content = $(this.Container);
            if (this.Container) {
                $content.animate({ scrollTop: $content[0].scrollHeight }, 300);
            }
        }, 50);
    }

    SelectAppointment(appoinment: AppointmentOption) {
        if (appoinment.isSelected() || appoinment.isDisabled()) {
            return;
        }

        const dialog = new ConfirmationDialog({
            Text: CONFIRMATIONS.SELECT_APPOINTMENT.replace(
                '{appointment}',
                `<span class="text-mono font-medium">${this.FormatTime(appoinment.startTime)}</span>`
            ),
            Type: Types.Question,
            HideLogo: true,
        });

        dialog.On(EVENTS.CONFIRM_SELECTED, this, async () => {
            appoinment.isSelected(true);
            await this.CreateAppointment(appoinment);

            _.each(this.Appointments(), (appoinment) => {
                if (appoinment.isSelected()) {
                    return;
                }
                appoinment.isDisabled(true);
            });
        });

        dialog.Show();
    }

    async SheduleAppointment() {
        BlockUI.Block();

        this._responseId = '';

        let appoinments = await AssistantApi.StartGuestPlanningChat({
            EntityId: this._entityId,
            RecordId: this._recordId,
            ResponseId: this._responseId,
            CommandId: this._commandId,
            CommandToken: this._commandToken,
            IsChatSession: true,
        }).fail((err) => {
            Notifier.Failed(err.message);
            BlockUI.Unblock();
        });

        BlockUI.Unblock();

        this.CaptureResponseId(appoinments);
        this.AddAssistantMessage(this.GetAssistantMessage(appoinments));
        this.Show();
    }

    private GetAssistantMessage(prompt: PromptDto) {
        return prompt.Messages[0];
    }

    private CaptureResponseId(prompt: PromptDto) {
        if (prompt && prompt.ResponseId) {
            this._responseId = prompt.ResponseId;
        }
    }

    async GenerateSQL(){
        BlockUI.Block({ Target: this.Container });

        let prompt = await AssistantApi.SqlMessage({
                Message: "Generate Final SQL",
                responseId: this._responseId,
            })
                .always(() => {
                   BlockUI.Unblock(this.Container);
                })
                .fail((err) => Notifier.Failed(err.message));

        this.CaptureResponseId(prompt);
        this.Trigger('SAVE', { sql: prompt.Messages[0].Content });
        this.Close();
    }

    async GenerateFunction(){
        BlockUI.Block({ Target: this.Container });

        let prompt = await AssistantApi.SendFunctionMessage({
                Message: "Generate Final Function",
                responseId: this._responseId,
            })
                .always(() => {
                   BlockUI.Unblock(this.Container);
                })
                .fail((err) => Notifier.Failed(err.message));

        this.CaptureResponseId(prompt);
        this.Trigger('SAVE', { function: prompt.Messages[0].Content });
        this.Close();
    }

    async RefresMetadata(){
        this._messages([]);
        await this.LoadData(true);
        Notifier.Success(this._labels.AI_SQ_METADATA_REFRESHED);
    }
}
